import checkboxToggle from './checkboxToggle.hbs';

class CheckboxToggleController {
    constructor(container, registerFormContainer, requestFormContainer, defaultMessageContainer, backToSignInElement) {
        this.container = container;
        this.template = checkboxToggle;
        this.registerFormContainer = registerFormContainer;
        this.requestFormContainer = requestFormContainer;
        this.defaultMessageContainer = defaultMessageContainer;
        this.backToSignInElement = backToSignInElement;
        
        this.render();
        this.enableUI();
    }
    
    render () {
        this.container.innerHTML = this.template();
    }

    enableUI () {
        this.container.addEventListener('click', this.handleToggle.bind(this));
        this.backToSignInElement.addEventListener('click', this.handleBackToSignInClick.bind(this));
    }

    handleToggle (e) {
        if (e.target.matches('input[type="checkbox"]')) {
            if (e.target.checked) {
                this.clearAllCheckboxes();
                e.target.checked = true;
                this.updateVisibility(e.target);
            } else {
                this.setDefaultView();
            }
        }
    }

    handleBackToSignInClick () {
        this.setDefaultView();
        this.clearAllCheckboxes();
    }

    clearAllCheckboxes () {
        this.container.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            checkbox.checked = false
        });
    }

    setDefaultView () {
        this.backToSignInElement.classList.add('isHidden');
        this.defaultMessageContainer.classList.remove('isHidden');
        this.requestFormContainer.classList.add('isHidden');
        this.registerFormContainer.classList.add('isHidden');
    }

    updateVisibility (checkedElement) {
        this.backToSignInElement.classList.remove('isHidden');
        if (checkedElement.name === "Service Provider") {
            this.defaultMessageContainer.classList.add('isHidden');
            this.requestFormContainer.classList.remove('isHidden');
            this.registerFormContainer.classList.add('isHidden');
        } 
        if (checkedElement.name === "Associate") {
            this.defaultMessageContainer.classList.add('isHidden');
            this.requestFormContainer.classList.add('isHidden');
            this.registerFormContainer.classList.remove('isHidden');
        }
    }
}

export default CheckboxToggleController;
